import { apiScheduleTelemed } from 'www/api'
import getInitialDay from 'www/modules/Schedule/classes/ScheduleData/functions/renderData/helpers/getInitialDay'

/**
 * @description
 * Возвращает объект Map, который используется дальше для рендера календарей для записи к врачу(на странице списка врачей и странице врача).
 * Функция возвращает список, который состоит из множества объектов рендера, или же только из одного.
 * При спецразмещении может быть несколько дубликатов карточек клиник. Сопоставление переменной 'isSingleRender' точно сообщает - в каком контейнере произошло изменение.
 * Если при клике передан parentCard и не найдено сопоставление - будет ошибка, которая ловится в вызывающем модуле.
 *
 * @param {object} opts -
 * @param {object} opts.data - собранные данные со страницы - интерфейс 'getModuleDataInterface'
 * @param { HTMLElement } opts.parentCard - карточка в списке, в которой необходимо заменить расписание
 * @param {Array<object>} opts.response - ответ на запрос
 * @param {string} opts.dataItem - data атрибут родителя
 *
 * @returns { Map } - данные для рендера списка календарей
 */

const getRenderDoctorsData = opts => {
  const {
    data,
    response,
    dataItem,
    parentCard,
    isTelemed,
  } = opts
  const resultData = new Map()

  data.items.forEach((pageData, scheduleContainer) => {
    let { lpuId } = pageData

    const {
      wpListId,
      doctorId,
      coverNode,
      wpListAppType,
      doctorSpecialtyId,
      hasSpecialPlacement,
      wpListLpuWorkingText,
      wpListLpuPhone,
    } = pageData

    const scheduleDataList = wpListId.length // объекты с расписанием для всех workplace
    // Если список wpListId не пустой, значит рендер происходит на странице списка врачей, там несколько workplace.
    // На этой странице 'lpuId' заранее неизвестен, так как workplaces могут иметь разные id.
      ? response.filter(responseItem => (
        isTelemed
          ? responseItem.schedule_data.find(({ doctor_id: responseDoctorId }) => responseDoctorId === doctorId)
          : responseItem.doctor_id === doctorId
      ))
    // Значит рендер происходит на странице врача. На этой странице известен 'lpuId'.
    // Поэтому можно отфильтровать по 2 полям и найти сразу нужные данные, без дополнительных проверок
      : response.filter(responseItem => (
        isTelemed
          ? lpuId === responseItem.lpu_id
            && responseItem.schedule_data.find(({ doctor_id: responseDoctorId }) => responseDoctorId === doctorId)
          : lpuId === responseItem.lpu_id && responseItem.doctor_id === doctorId
      ))
    const isListRender = !parentCard // рендер списка календарей
    const isSingleRender = parentCard === coverNode // рендер только 1 календаря

    if (!scheduleDataList.length) {
      return
    }

    if (!(isListRender || isSingleRender)) {
      return
    }

    scheduleDataList.forEach(scheduleData => {
      if (wpListId.length) { // Условие актуально только для списка врачей
        lpuId = scheduleData.lpu_id

        const hasScheduleDataInWpList = wpListId.includes(lpuId)
                    && Number(scheduleContainer.getAttribute('data-lpu-id')) === lpuId // ToDo schedule-important избавиться от привязки к DOM дереву

        if (!hasScheduleDataInWpList) { // Список lpu id должен совпадать с данными ответа и узел для монтирования расписания должен содержать такой же lpu id
          return
        }
      }

      const slots = isTelemed
        ? apiScheduleTelemed.transformSlots(
          scheduleData.schedule_data.find(({ doctor_id: responseDoctorId }) => responseDoctorId === doctorId).schedule,
        )
        : scheduleData.slots
      const days = Object.keys(slots)
      const daysWithSlots = days.filter(date => slots[date].length)

      const initDay = getInitialDay({
        daysWithSlots,
        currentSlots: slots,
      })

      const wpLpuWorkingText = wpListLpuWorkingText?.find(workplace => workplace[lpuId]) || {}
      const lpuWorkingText = wpLpuWorkingText[lpuId] || ''

      const wpLpuPhone = wpListLpuPhone?.find(workplace => workplace[lpuId]) || {}
      const lpuPhone = wpLpuPhone[lpuId] || ''

      const appointmentTypeData = wpListAppType.find(item => item[lpuId]) || {}
      const appointmentType = appointmentTypeData[lpuId] || ''

      resultData.set(scheduleContainer, {
        days,
        slots,
        lpuId,
        initDay,
        dataItem,
        doctorId,
        lpuPhone,
        data: slots,
        lpuWorkingText,
        options: slots,
        useRedirect: true,
        appointmentType,
        isAppointmentDoctor: true,
        doctorSpec: doctorSpecialtyId,
        specPlacement: hasSpecialPlacement,
      })
    })
  })

  return resultData
}

export default getRenderDoctorsData
